import { gql } from "@apollo/client"
import { FilterSelection, GroupCount, useCountShipmentLegsQuery } from "gen/graphql"
import { DateTime } from "luxon"

export function useShipmentLegsCount(
  filterSelection: FilterSelection[],
  fromDate: DateTime,
  toDate: DateTime,
  groupBy?: string | null,
): { data: GroupCount[]; loading: boolean } {
  const { data, loading } = useCountShipmentLegsQuery({
    variables: {
      request: {
        filters: filterSelection.map((filter) => ({
          filterAttributeId: filter.filterAttributeId,
          filterTermIds: filter.filterTermIds,
        })),
        dateSpan: {
          startDate: {
            year: fromDate.year,
            month: fromDate.month,
            day: fromDate.day,
          },
          endDate: {
            year: toDate.year,
            month: toDate.month,
            day: toDate.day,
          },
        },
        groupBy: groupBy ?? null,
      },
    },
  })

  const shipmentLegsCount = data?.CountShipmentLegs.groupCounts ?? []
  return { data: shipmentLegsCount, loading }
}

export const GROUP_COUNT_FRAGMENT = gql`
  fragment GroupCount on GroupCount {
    group
    count
  }
`

export const SHIPMENT_LEGS_QUERY = gql`
  query countShipmentLegs($request: CountShipmentLegsRequest!) {
    CountShipmentLegs(request: $request) {
      groupCounts {
        ...GroupCount
      }
    }
  }
`
